module.exports = __webpack_public_path__ + "static/contentmore-566b02c1f56f653d33f51e3cec84e1d6.png";